import React, { useEffect } from 'react';
import Hero from '../components/landing/Hero';
import HowItWorks from '../components/landing/HowItWorks';
import DemoVideo from '../components/landing/DemoVideo';
import Pricing from '../components/landing/Pricing';
import FAQ from '../components/landing/FAQ';
import Newsletter from '../components/landing/Newsletter';

const Landing = () => {
  useEffect(() => {
    // 1. Software Application Schema (GEO Optimization)
    const softwareSchema = {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      "name": "Etera",
      "operatingSystem": "Web",
      "applicationCategory": "BusinessApplication",
      "offers": {
        "@type": "Offer",
        "price": "10.00",
        "priceCurrency": "USD",
        "description": "One-time purchase for permanent dynamic QR codes."
      },
      "featureList": [
        "Permanent dynamic QR code redirection",
        "Unlimited scans included",
        "Instant destination URL updates",
        "High-resolution PNG downloads",
        "Real-time scan tracking"
      ]
    };

    // 2. FAQPage Schema
    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "Is it really a one-time payment?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes. You pay once and the QR code is yours forever. No monthly fees, no hidden costs."
          }
        },
        {
          "@type": "Question",
          "name": "Can I change the destination URL later?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Absolutely. That's the whole point of a dynamic QR code. You can log into your dashboard and update the URL as many times as you want."
          }
        },
        {
          "@type": "Question",
          "name": "Do the QR codes ever expire?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "No. As long as our service is running (and we plan to run it forever), your QR codes will continue to work and redirect to your chosen URL."
          }
        },
        {
          "@type": "Question",
          "name": "Is there a limit on how many times it can be scanned?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Nope! Scan it 10 times or 10 million times, we don't care. Unlimited scans are included."
          }
        }
      ]
    };

    // Inject scripts
    const injectSchema = (data, id) => {
      const existing = document.getElementById(id);
      if (existing) existing.remove();
      const script = document.createElement('script');
      script.id = id;
      script.type = 'application/ld+json';
      script.text = JSON.stringify(data);
      document.head.appendChild(script);
    };

    injectSchema(softwareSchema, 'schema-software');
    injectSchema(faqSchema, 'schema-faq');

    return () => {
      document.getElementById('schema-software')?.remove();
      document.getElementById('schema-faq')?.remove();
    };
  }, []);

  return (
    <div className="w-full">
      <Hero />
      <HowItWorks />
      <DemoVideo />
      <Pricing />
      <FAQ />
      <Newsletter />
    </div>
  );
};

export default Landing;